export default __webpack_public_path__ + "static/media/news81.497adae0.jpg";